// extracted by mini-css-extract-plugin
module.exports = {"link":"link__1fSLC","active":"active__2gIRg"};